// extracted by mini-css-extract-plugin
export var readonly = "_ho-1";
export var star = "_ho-0";